import { c as _c } from "react/compiler-runtime";
import type { DataIdentifier } from '@onefootprint/request-types/dashboard';
import { SegmentedControl } from '@onefootprint/ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { hasEntityBankAccounts, hasEntityCards } from '@/entities/utils/has-entity';
import type { WithEntityProps } from '@/entity/components/with-entity';
import useDecryptControls from '@/entity/hooks/use-decrypt-controls';
import Fieldset from '../../../fieldset';
import BankAccountFields from './components/bank-account-fields';
import CardFields from './components/card-fields';
const FinancialFieldset = t0 => {
  const $ = _c(23);
  const {
    entity
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "fieldset"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const decryptControls = useDecryptControls();
  let t2;
  if ($[1] !== entity) {
    t2 = hasEntityCards(entity) && hasEntityBankAccounts(entity);
    $[1] = entity;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const hasCardsAndBankAccounts = t2;
  let t3;
  if ($[3] !== entity) {
    t3 = hasEntityCards(entity);
    $[3] = entity;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const [isCard, setIsCard] = useState(t3);
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [];
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const [selectedItemDis, setSelectedItemDis] = useState(t4);
  let t5;
  if ($[6] !== selectedItemDis) {
    t5 = selectedItemDis.map(_temp);
    $[6] = selectedItemDis;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t) {
    t6 = t(_temp2);
    $[8] = t;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== decryptControls || $[11] !== hasCardsAndBankAccounts || $[12] !== isCard || $[13] !== t) {
    t7 = hasCardsAndBankAccounts && decryptControls.step !== "selecting-fields" && <div className="-my-0.5"><SegmentedControl size="compact" variant="secondary" aria-label={t(_temp3)} options={[{
        label: t(_temp4),
        value: "cards"
      }, {
        label: t(_temp5),
        value: "bank-accounts"
      }]} value={isCard ? "cards" : "bank-accounts"} onChange={value => {
        setIsCard(value === "cards");
      }} /></div>;
    $[10] = decryptControls;
    $[11] = hasCardsAndBankAccounts;
    $[12] = isCard;
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== entity || $[16] !== isCard) {
    t8 = isCard ? <CardFields entity={entity} setSelectedItemDis={setSelectedItemDis} /> : <BankAccountFields entity={entity} setSelectedItemDis={setSelectedItemDis} />;
    $[15] = entity;
    $[16] = isCard;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t5 || $[19] !== t6 || $[20] !== t7 || $[21] !== t8) {
    t9 = <Fieldset fields={t5} title={t6} action={t7}>{t8}</Fieldset>;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
};
export default FinancialFieldset;
function _temp(di) {
  return {
    di
  };
}
function _temp2($) {
  return $.financial.title;
}
function _temp3($_0) {
  return $_0.financial.control.aria;
}
function _temp4($_1) {
  return $_1.financial.control.cards;
}
function _temp5($_2) {
  return $_2.financial.control.bankAccounts;
}